import { Injectable } from '@angular/core';
import { EPlatformFeature } from '@enums/campaign.enum';
import { TranslateService } from '@ngx-translate/core';
import { ICtaAnalyticsData } from '../../cta-analytics-table.interface';
import { BaseAnalyticsFormatter } from './base-analytics-formatter';
import { FacebookPostAnalyticsFormatter } from './facebook-post-analytics-formatter';
import { InstagramPostAnalyticsFormatter } from './instagram-post-analytics-formatter';
import { InstagramReelAnalyticsFormatter } from './instagram-reel-analytics-formatter';
import { InstagramStoryAnalyticsFormatter } from './instagram-story-analytics-formatter';
import { TikTokPostAnalyticsFormatter } from './tiktok-post-analytics-formatter';
import { TwitchStreamAnalyticsFormatter } from './twitch-stream-analytics-formatter';
import { XPostAnalyticsFormatter } from './x-post-analytics-formatter';
import { YoutubeShortAnalyticsFormatter } from './youtube-short-analytics-formatter';
import { YoutubeStreamAnalyticsFormatter } from './youtube-stream-analytics-formatter';
import { YoutubeVodAnalyticsFormatter } from './youtube-vod-analytics-formatter';

@Injectable({
  providedIn: 'root',
})
export class AnalyticsFormatterFactory {
  public createFormatter(
    platformFeature: EPlatformFeature,
    execution: ICtaAnalyticsData,
    translate: TranslateService,
  ): BaseAnalyticsFormatter {
    switch (platformFeature) {
      case EPlatformFeature.twitchStream:
        return new TwitchStreamAnalyticsFormatter(execution, translate);
      case EPlatformFeature.instagramPost:
        return new InstagramPostAnalyticsFormatter(execution, translate);
      case EPlatformFeature.instagramReel:
        return new InstagramReelAnalyticsFormatter(execution, translate);
      case EPlatformFeature.instagramStory:
        return new InstagramStoryAnalyticsFormatter(execution, translate);
      case EPlatformFeature.tiktokPost:
        return new TikTokPostAnalyticsFormatter(execution, translate);
      case EPlatformFeature.facebookPost:
        return new FacebookPostAnalyticsFormatter(execution, translate);
      case EPlatformFeature.xPost:
        return new XPostAnalyticsFormatter(execution, translate);
      case EPlatformFeature.youtubeStream:
        return new YoutubeStreamAnalyticsFormatter(execution, translate);
      case EPlatformFeature.youtubeShort:
        return new YoutubeShortAnalyticsFormatter(execution, translate);
      case EPlatformFeature.youtubeVod:
        return new YoutubeVodAnalyticsFormatter(execution, translate);
      default:
        throw new Error(`No analytics formatter available for platform feature: ${platformFeature}`);
    }
  }
}
